<template>
  <suspense v-if="!error">
    <template #default>
      <layout-guest>
        <template #default>
          <slot />
        </template>
      </layout-guest>
    </template>
    <template #fallback>
      <div class="gradient flex h-screen w-screen items-center justify-center">
        <wui-icon
          name="spinner"
          class="h-32 w-32 text-primary"
        />
      </div>
    </template>
  </suspense>
  <div
    v-else
    class="flex h-screen w-screen items-center justify-center bg-primary-tints-500 bg-linear-to-tr from-accent-tints-600"
  >
    <p>{{ error.message }}</p>
  </div>
</template>

<script setup lang="ts">
import { WuiIcon } from '@wui/common-library'
import { defineAsyncComponent, onErrorCaptured, Ref, ref } from 'vue'

const LayoutGuest = defineAsyncComponent(() => import('@/widgets/layout').then(({ LayoutGuest }) => LayoutGuest))

const error: Ref<Error | null> = ref(null)

onErrorCaptured((err: Error) => {
  error.value = err
})
</script>
